import React, { useContext } from "react";
import { cssVar, forwardRef, getCSSVar, Text as ChakraText, useTheme, } from "@chakra-ui/react";
import { SkeletonContext } from "./skeleton-context";
import { SkeletonText } from "./skeleton-text";
export const Text = forwardRef(({ isMonospace, isTruncated = false, size = "md", children, color: customColor, ...props }, ref) => {
    const skeleton = useContext(SkeletonContext);
    // This code supports 3 use cases:
    //  1. Default color is used for this `Text`
    //  2. Color is inherited from the parent component via `--hightouch-text-color` CSS variable
    //  3. Custom `color` is passed to this `Text` and inherited color is ignored
    const defaultColor = cssVar("chakra-colors-text-primary").reference;
    const inheritedColor = cssVar("hightouch-text-color", defaultColor).reference;
    const color = customColor ?? inheritedColor;
    const theme = useTheme();
    return (React.createElement(ChakraText, { ref: ref, as: "span", size: size, fontFamily: isMonospace ? "mono" : undefined, position: skeleton ? "relative" : undefined, color: skeleton ? "transparent" : color, 
        // If custom color is passed to this `Text`, define `--hightouch-text-color` CSS variable
        // so that nested `Text` components will inherit this custom color too
        sx: customColor
            ? {
                [cssVar("hightouch-text-color").variable]: getCSSVar(theme, "colors", customColor),
            }
            : undefined, ...(isTruncated
            ? {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }
            : {}), ...props },
        children,
        skeleton && React.createElement(SkeletonText, null)));
});
Text.displayName = "Text";
